import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { RoleGuard } from "app/guards";
import { EncargadosProvider } from "./encargados-context";
import { EncargadosTable } from "./encargados-table";
import { EncargadoForm } from "./encargado-form";

export function EncargadosRoutes() {
  return (
    <RoleGuard roles={["empresa:encargados"]}>
      <EncargadosProvider>
        <Routes>
          <Route path="/" element={<Outlet />}>
            <Route index element={<EncargadosTable />} />

            <Route path="add" element={<EncargadoForm />} />

            <Route path=":encargado_id" element={<Outlet />}>
              <Route index element={<Navigate to="edit" replace />} />

              <Route path="edit" element={<EncargadoForm />} />
            </Route>

            <Route path="*" element="Encargados: Page Not Found" />
          </Route>
        </Routes>
      </EncargadosProvider>
    </RoleGuard>
  );
}
